"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var form_service_1 = require("../services/form.service");
var input_component_1 = require("./input.component");
var TextareaComponent = (function (_super) {
    __extends(TextareaComponent, _super);
    function TextareaComponent(_formService) {
        var _this = _super.call(this, _formService) || this;
        _this._formService = _formService;
        _this.changeData = new core_1.EventEmitter();
        console.log('teta');
        return _this;
    }
    TextareaComponent.prototype.ngOnChanges = function (changes) {
        for (var propName in changes) {
            var prop = changes[propName];
            var cur = prop.currentValue;
            var prev = JSON.stringify(prop.previousValue);
            if (propName === 'tyData' && cur && (prev !== '{}')) {
                console.log(cur);
                this.setData(cur);
            }
        }
    };
    return TextareaComponent;
}(input_component_1.InputComponent));
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], TextareaComponent.prototype, "tyName", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], TextareaComponent.prototype, "tyPlaceholder", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], TextareaComponent.prototype, "tyData", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], TextareaComponent.prototype, "required", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], TextareaComponent.prototype, "changeData", void 0);
TextareaComponent = __decorate([
    core_1.Component({
        selector: 'ty-textarea',
        template: "<div class=\"ty-textarea\">\n    <textarea #box type=\"text\" [name]=\"tyName\" [(ngModel)]=\"tyData\" (ngModelChange)=\"setData(box.value)\" placeholder=\"{{tyPlaceholder}}\"></textarea>\n    </div>",
        styles: [require('./textarea.component.css')],
        providers: [form_service_1.FormService]
    }),
    __metadata("design:paramtypes", [form_service_1.FormService])
], TextareaComponent);
exports.TextareaComponent = TextareaComponent;
